const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const getToken = () => localStorage.getItem("accessToken");

const request = async (path: string, options: RequestInit = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${getToken() || ""}`,
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw data || { message: "Connection request failed" };
  }

  return data;
};

// Send interest
export const sendInterest = async (receiverId: number) => {
  return request("/connection/request", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ receiverId }),
  });

};

// Check access (IMPORTANT)
export const checkProfileAccess = async (userId: number) => {
  return request(`/connection/can-view/${userId}`);
};

export const getNotifications = async () => {
  return request("/connection/notifications");
};
export const getSentRequests = async () => {
  return request("/connection/all-requests");
};

// Accept / Reject request
export const updateConnectionStatus = async (requestId: number, status: "accepted" | "rejected") => {
  return request("/connection/request/update-status", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ requestId, status }),
  });

};
